import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import FamilySupportWelfareDetails from '../../subdepartmentdetails/FamilySupportWelfare'


function FamilySupportWelfare() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Family Support and Welfare Assistance || Family and Children Services";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Family Community Services"
            title="Family Support Welfare"
            subtitledown="Department of Family & Children Services"
           />
            <FamilySupportWelfareDetails/>
        </div>
    </>
  )
}

export default FamilySupportWelfare